/* ==========================================================================
   product.js — PDP interactions
   - Gallery thumbnail swap
   - Quantity stepper
   - Purchase-type toggle (dynamic pricing from data attributes)
   - Variant selection
   All prices read from Shopify product data — nothing hardcoded.
   ========================================================================== */

(() => {
  'use strict';

  /* ---------- Gallery thumbnail swap ---------- */
  const mainImg = document.getElementById('gallery-main-img');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.gallerySrc;
      const alt = thumb.dataset.galleryAlt || '';
      if (!src || !mainImg) return;
      mainImg.src = src;
      mainImg.alt = alt;
      thumbs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');
    });
  });

  /* ---------- Product data ---------- */
  const productDataEl = document.getElementById('product-data');
  let productData = { variants: [], available: true };
  if (productDataEl) {
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) { /* ignore */ }
  }

  /* ---------- Quantity stepper ---------- */
  const qtyInput = document.querySelector('[data-qty-input]');
  const qtyInc = document.querySelector('[data-qty-increment]');
  const qtyDec = document.querySelector('[data-qty-decrement]');

  const clampQty = (n) => Math.max(1, Math.min(99, Number(n) || 1));

  if (qtyInput && qtyInc && qtyDec) {
    qtyInc.addEventListener('click', () => {
      qtyInput.value = clampQty(parseInt(qtyInput.value, 10) + 1);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qtyDec.addEventListener('click', () => {
      qtyInput.value = clampQty(parseInt(qtyInput.value, 10) - 1);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qtyInput.addEventListener('change', () => {
      qtyInput.value = clampQty(qtyInput.value);
      updateCtaTotal();
    });
  }

  /* ---------- Purchase toggle (one-time vs subscribe) ---------- */
  const toggleEl = document.querySelector('[data-purchase-toggle]');
  const radios = document.querySelectorAll('.purchase-toggle input[type="radio"]');
  const cta = document.querySelector('.buy-panel__cta');
  const priceEl = document.querySelector('[data-product-price]');

  // Read prices from Liquid-generated data attributes (in cents)
  const onetimePriceCents = toggleEl ? parseInt(toggleEl.dataset.onetimePrice, 10) : 0;
  const subscribePriceCents = toggleEl ? parseInt(toggleEl.dataset.subscribePrice, 10) : 0;

  // Shopify money format: cents → dollars with 2 decimal places
  const formatMoney = (cents) => {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  };

  const getUnitPriceCents = () => {
    const selected = document.querySelector('.purchase-toggle input[type="radio"]:checked');
    if (selected && selected.value === 'subscribe') return subscribePriceCents;
    return onetimePriceCents || (productData.variants[0] ? productData.variants[0].price : 0);
  };

  const updateCtaTotal = () => {
    if (!cta || !qtyInput) return;
    const qty = clampQty(parseInt(qtyInput.value, 10));
    const unitCents = getUnitPriceCents();
    const totalCents = unitCents * qty;

    if (priceEl) priceEl.textContent = formatMoney(unitCents);
    if (productData.available !== false) {
      cta.textContent = `Add to Cart \u2014 ${formatMoney(totalCents)}`;
    }
  };

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      document.querySelectorAll('.purchase-toggle__option').forEach((opt) => {
        opt.classList.toggle('is-active', opt.querySelector('input').checked);
      });
      updateCtaTotal();
    });
  });

  /* ---------- Variant selection ---------- */
  const variantInputs = document.querySelectorAll('[data-option-index]');
  const atcBtn = document.querySelector('[data-add-to-cart]');

  const getSelectedOptions = () => {
    const options = [];
    document.querySelectorAll('.product-hero__option').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      if (checked) options.push(checked.value);
    });
    return options;
  };

  const findVariant = (options) => {
    return productData.variants.find((v) => {
      return options.every((opt, i) => v[`option${i + 1}`] === opt);
    });
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const options = getSelectedOptions();
      const variant = findVariant(options);
      if (!variant) return;

      // Update variant ID on add-to-cart button
      if (atcBtn) atcBtn.dataset.variantId = variant.id;

      // Update price display
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      // Update gallery image if variant has a featured image
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.alt = variant.featured_image.alt || '';
      }

      // Update availability
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        if (variant.available) {
          updateCtaTotal();
        } else {
          atcBtn.textContent = 'Sold Out';
        }
      }

      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    });
  });

  // Initial render
  updateCtaTotal();
})();
